<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.46938 18.1295L5.21967 13.8798C4.92678 13.5869 4.92678 13.1121 5.21967 12.8192C5.51256 12.5263 5.98744 12.5263 6.28033 12.8192L9.24972 15.7886V2.75C9.24972 2.3358 9.58551 2 9.99972 2C10.4139 2 10.7497 2.3358 10.7497 2.75V15.7885L13.7191 12.8192C14.012 12.5263 14.4869 12.5263 14.7797 12.8192C15.0726 13.1121 15.0726 13.5869 14.7797 13.8798L10.53 18.1295C10.5218 18.1378 10.5134 18.1458 10.5048 18.1536C10.2837 18.3554 9.97097 18.4011 9.70841 18.2905C9.62153 18.254 9.54015 18.2003 9.46938 18.1295Z"
            fill="currentColor"
        />
    </svg>
</template>
